// GraphQL mutations for HR Dashboard

export const updateFlagStatus = /* GraphQL */ `
  mutation UpdateFlagStatus(
    $flagId: ID!
    $newStatus: String!
    $notes: String
  ) {
    updateFlagStatus(flagId: $flagId, newStatus: $newStatus, notes: $notes) {
      success
      message
      flag {
        flagId
        status
        notes {
          noteId
          content
          createdAt
        }
        statusHistory {
          historyId
          oldStatus
          newStatus
          changedAt
          changedBy
          changedByName
          notes
        }
      }
    }
  }
`

export const addFlagNote = /* GraphQL */ `
  mutation AddFlagNote(
    $flagId: ID!
    $content: String!
  ) {
    addFlagNote(flagId: $flagId, content: $content) {
      success
      message
      note {
        noteId
        content
        authorEmail
        authorName
        createdAt
        updatedAt
      }
    }
  }
`

